<template>
    <DsTextInput
        v-bind="$props"
        :model-value="model"
        type=""
    >
        <template
            v-for="(_, slot) in $slots"
            #[slot]="scope"
        >
            <slot
                :name="slot"
                v-bind="scope"
            />
        </template>

        <template #input="{ inputClass, elementId, hasError }">
            <Money3Component
                v-model.number="dollarValue"
                v-bind="moneyConfig"
                :id="elementId"
                ref="moneyInputRef"
                :class="[inputClass, { 'has-error': hasError }]"
                :disabled
            />
        </template>
    </DsTextInput>
</template>

<script setup lang="ts">
import { convertCentsToDollars, convertDollarsToCents } from '@/shared/utils/format-number';
import DsTextInput from '@ds/form/input/text/DsTextInput.vue';
import type { DsBaseInputProps } from '@ds/form/input/text/text-input.types';
import { Money3Component } from 'v-money3';
import { computed, useTemplateRef } from 'vue';

interface Money3Config {
    masked?: boolean;
    prefix?: string;
    suffix?: string;
    thousands?: string;
    decimal?: string;
    precision?: number;
    disableNegative?: boolean;
    disabled?: boolean;
    min?: number;
    max?: number;
    allowBlank?: boolean;
    minimumNumberOfCharacters?: number;
    shouldRound?: boolean;
    focusOnRight?: boolean;
}

interface DsMoneyInputProps extends DsBaseInputProps {
    moneyConfig?: Money3Config;
}

defineProps<DsMoneyInputProps>();

const model = defineModel<number>({ default: 0 });

const moneyInputRef = useTemplateRef('moneyInputRef');
const inputElement = computed(() => moneyInputRef.value?.$el);

const dollarValue = computed({
    get: () => {
        return convertCentsToDollars(model.value);
    },
    set: (newValue: number | string) => {
        model.value = convertDollarsToCents(newValue);
    },
});

defineExpose({
    inputElement,
});
</script>
